<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import ModalDialog from "./ModalDialog.vue";
import HtmlContent from "./HtmlContent.vue";
import CrossIcon from "../../icons/CrossIcon.vue";
import { ExtendedProductInformationLayouts } from '@/types/extendedProductInformation';

interface Props {
	modalName: string;
	content: ExtendedProductInformationLayouts;
}
const props = defineProps<Props>();
const currentModalName = computed(() => store.getters.currentModalName);
const isCurrent = computed(() => currentModalName.value === props.modalName);

const i18n = window.measurementSelectorVariables.i18n;

const store = useStore();

function closeModal() {
	store.commit('updateCurrentModalName', null);
}
</script>

<template>
	<Teleport to="body">
		<modal-dialog :modal-name="modalName" :isOpen="isCurrent">
			<button
				class="info-modal-close"
				type="button"
				@click="closeModal"
				ref="closeButton"
				:aria-label="i18n.closeModal"
			>
				<cross-icon />
			</button>
			<html-content
				:content="content"
			></html-content>
		</modal-dialog>
	</Teleport>
</template>

<style scoped lang="scss">
.info-modal-close {
	height: 40px;
	width: 40px;
	padding: 4px;
	position: fixed;
	top: 10px;
	right: 0;
	z-index: 2;
}

.info-modal-close > svg,
.info-modal-close > svg > * {
	width: 2rem;
	height: 2rem;
	stroke-width: 5px;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to{
	opacity: 0;
}
</style>
